// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__jg35W","input":"Checkbox_input__9ZN4+"};